//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@/mixins/global'
import axios, {
  CancelToken
} from 'axios'
import { constants } from 'buffer'

export default {
  data () {
    return {
      SoStatus: 'ALL',
      pageCurrent: 1,
      maxPage: 1,
      dataWIP: [],
      cntLate: 0,
      cntAlert: 0,
      cntNormal: 0,
      UserAccessData: {}

    }
  },
  created () {
    this.chkAuthen('', '')
    this.pullData()
  },
  mounted () {
    this.getUserAccessData()
  },
  computed: {

  },
  watch: {

  },
  methods: {
    pullData () {
      this.pulling = setInterval(() => {
        var currentdate = new Date()
        // eslint-disable-next-line eqeqeq
        if (currentdate.getMinutes() % 15 == 0 && currentdate.getSeconds() == 0) {
          this.LoadData(this.pageCurrent)
          console.log(currentdate)
        }
      }, 1000)
    },
    getUserAccessData () {
      let params = new FormData()
      params.append('uid', this.$store.getters.uid)
      axios({
        method: 'post',
        url: this.$api + 'master.php/UserAccessData',
        data: params
      }).then(res => {
        // console.log(res.data)
        this.UserAccessData = res.data
        this.LoadData(1)
      })
    },
    async LoadData (page) {
      debugger
      this.pageCurrent = page
      let params = new FormData()
      console.log(this.pageCurrent)
      console.log(this.SoStatus)
      console.log(this.$route.params.grp)
      // params.append("page", 1)
      params.append('page', this.pageCurrent)
      params.append('status', this.SoStatus)
      params.append('grp', this.$route.params.grp)
      // params.append("grpIn", 'ALL')
      params.append('grpIn', this.UserAccessData.PatternIn)
      console.log(params)
      axios({
        method: 'post',
        url: this.$api + 'readinessWIP.php/wip_pattern',
        data: params
      }).then(res => {
        console.log(res.data)
        this.maxPage = res.data.totalPage
        this.dataWIP = res.data.Data
        // this.maxPage = res.data.totalPage
        this.cntLate = res.data.late
        this.cntAlert = res.data.alert
        this.cntNormal = res.data.normal
        // this.MasterData()
      })
    },
    getWW (txt) {
      var str = txt
      var res = str.substring(0, 4) + '-' + str.substring(4, 6)
      return res
    },
    getLate (obj) {
      // eslint-disable-next-line eqeqeq
      if (obj.TARGET_CHK == 'X') {
        return 'bg-green-2 text-black'
      } else if (obj.TARGET_DATE_TXT > obj.CDATE) {
        return 'bg-green-2 text-black'
      // eslint-disable-next-line eqeqeq
      } else if (obj.TARGET_DATE_TXT == obj.CDATE) {
        return 'bg-yellow-2 text-black'
      } else {
        return 'bg-red-2 text-black'
      }
    },
    showLate () {
      // eslint-disable-next-line eqeqeq
      if (this.ShowStatus == 'Late') {
        this.ShowStatus = ''
      } else {
        this.ShowStatus = 'Late'
      }
      // console.log(this.ShowStatus)
      this.LoadData(1)
    },
    showAlert () {
      // eslint-disable-next-line eqeqeq
      if (this.ShowStatus == 'Alert') {
        this.ShowStatus = ''
      } else {
        this.ShowStatus = 'Alert'
      }
      // console.log(this.ShowStatus)
      this.LoadData(1)
    },
    showNormal () {
      // eslint-disable-next-line eqeqeq
      if (this.ShowStatus == 'Normal') {
        this.ShowStatus = ''
      } else {
        this.ShowStatus = 'Normal'
      }
      // console.log(this.ShowStatus)
      this.LoadData(1)
    }

  }
}
